export enum PaymentMethodChoices {
  CASH_PAYMENT = 1,
  LOAN_PAYMENT = 2,
  CREDIT_PAYMENT = 3,
  CASH_CREDIT_PAYMENT = 4,
  BNPL_PAYMENT = 5,
  CASHBACK_PAYMENT = 6,
  CASHBACK_CASH_PAYMENT = 7,
}

export enum PaymentMethodValues {
  CASH_PAYMENT = 'cash_payment',
  LOAN_PAYMENT = 'loan_payment',
  CREDIT_PAYMENT = 'credit_payment',
  CASH_CREDIT_PAYMENT = 'cash_credit_payment',
  BNPL_PAYMENT = 'bnpl_payment',
  CASHBACK_PAYMENT = 'cashback_payment',
  CASHBACK_CASH_PAYMENT = 'cashback_cash_payment',
}

export const paymentTypeMap: Record<PaymentMethodValues, PaymentMethodChoices> =
  {
    [PaymentMethodValues.CASH_PAYMENT]: PaymentMethodChoices.CASH_PAYMENT,
    [PaymentMethodValues.LOAN_PAYMENT]: PaymentMethodChoices.LOAN_PAYMENT,
    [PaymentMethodValues.CREDIT_PAYMENT]: PaymentMethodChoices.CREDIT_PAYMENT,
    [PaymentMethodValues.CASH_CREDIT_PAYMENT]:
      PaymentMethodChoices.CASH_CREDIT_PAYMENT,
    [PaymentMethodValues.BNPL_PAYMENT]: PaymentMethodChoices.BNPL_PAYMENT,
    [PaymentMethodValues.CASHBACK_PAYMENT]:
      PaymentMethodChoices.CASHBACK_PAYMENT,
    [PaymentMethodValues.CASHBACK_CASH_PAYMENT]:
      PaymentMethodChoices.CASHBACK_CASH_PAYMENT,
  };

export enum PaymentCondition {
  ORDER_CASH = 'ORDER_CASH',
  ORDER_CREDIT = 'ORDER_CREDIT',
  STORE_ORDER_CASH = 'STORE_ORDER_CASH',
  STORE_ORDER_CREDIT = 'STORE_ORDER_CREDIT',
  INVALID = 'INVALID',
}

export enum TransactionTypesChoices {
  ORDER = 'order',
  STORE_ORDER = 'store_order',
}

export const AllPaymentTypeToPersian: Record<PaymentMethodChoices, string> = {
  1: 'پرداخت نقدی',
  2: 'پرداخت با وام',
  3: 'پرداخت اعتباری',
  4: 'پرداخت نقدی و اعتباری',
  5: 'پرداخت قسطی',
  6: 'پرداخت اعتباری',
  7: 'پرداخت نقدی و اعتباری',
};
